import { Button, Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import styles from "./SuccessModal.module.scss";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import { closeSuccessModal } from "@/redux/training/slice";
import { useNavigate } from "react-router-dom";
import contactUsImage from "@/assets/img/ContactUs.png";

export const SuccessModal = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { successModal } = useAppSelector(state => state.training);


  const handleCloseModal = () => {
    dispatch(closeSuccessModal());
  }

  const handleClick = () => {
    dispatch(closeSuccessModal());
    navigate("/");
  }
  
  return (
    <Modal
      title={ModalTexts.services.successModal.TITLE}
      subTitle={ModalTexts.services.successModal.SUB_TITLE}
      isOpen={successModal}
      setIsOpen={handleCloseModal}
      closeFunc={handleCloseModal}
      mobileContentSize="fixed"
    >
      <img src={contactUsImage} alt="success request send" className={styles.image} />
      <Button newStyles={styles.button} onClickFunc={handleClick}>
        Аренда кортов
      </Button>
    </Modal>
  );
};